module.exports = __webpack_public_path__ + "img/3-3.e1cb9374.svg";